import { Book } from "./book";
import React from "react";

export const Historische = (props) => {
  return (
    <div id="historische" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Historische Romane</h2>
          <p>Bisher erschienene Historische Romane</p>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-4 col-md-4 col-lg-4"
                  >
                    <Book
                      title={d.title}
                      largeImage={d.largeImage}
                      smallImage={d.smallImage}
                      langtext={d.langtext}
                    />
                    <div id={d.bodShop}></div>
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
  );
};
